class BbdCartStockProperty extends HTMLElement {
  constructor() {
    super();

    this.settings = {
      locale: this.dataset.locale || 'nl'
    };
    this.syncing = false;
    this.init();
  }

  async fetchStockMessage(variantId) {
    const url = 'https://viavai-backend.fly.dev/api/stock-message/' + variantId + '?locale=' + this.settings.locale;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching stock message:', error);
      return 'Unable to retrieve stock message at this time.';
    }
  }

  async updateLineItemProperties(item, mergedProps) {
    /* eslint-disable no-undef */
    const res = await fetch(`${Shopify.routes.root}cart/change.js`, {
      /* eslint-enable no-undef */
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: item.key, properties: mergedProps })
    });
    if (!res.ok) throw new Error('change.js mislukte');
    return res.json();
  }

  async syncCartStock(cartItems) {
    if (this.syncing) return;

    this.syncing = true;
    try {
      if (cartItems.length <= 0) return;

      for (const item of cartItems) {
        const message = await this.fetchStockMessage(item.variant_id);

        const current = item.properties || {};
        if (message.message && message.severity) {
          const merged = {
            ...current,
            _stock_status_message: message.message,
            _stock_status_severity: message.severity
          };
          await this.updateLineItemProperties(item, merged);
        }
      }
    } catch (e) {
      console.error('[bbd-stock-sync] fout:', e);
    } finally {
      this.syncing = false;
    }
  }

  init() {
    /* eslint-disable no-undef */
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      /* eslint-enable no-undef */
      if (event?.source === 'cart-items') {
        this.syncCartStock(event.cartData.items);
      }

      if (event?.source === 'product-form') {
        this.syncCartStock([event.cartData]);
      }
    });
  }
}

customElements.define('bbd-cart-stock-property', BbdCartStockProperty);
